import { render, staticRenderFns } from "./TransmissionOrdre.vue?vue&type=template&id=d856d10e"
import script from "./TransmissionOrdre.vue?vue&type=script&lang=js"
export * from "./TransmissionOrdre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports